import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";
import {
  initialFilterStateProps,
  useRoomFilterContext,
  useRoomListContext,
} from "../context";

export const useSubmit = () => {
  const { setParam } = useRoomListContext();
  const { filters } = useRoomFilterContext();
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as initialFilterStateProps;

    filters &&
      (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
        (key) => {
          const value = filters[key];
          if (!value) return;
          if (key.includes("PerCt")) {
            param = {
              ...param,
              [key]: Number(value),
            };
            return;
          }
          param = {
            ...param,
            [key]: value,
          };
        }
      );

    setParam(param);
  };

  return {
    onSubmit,
  };
};

export const detail = (props: any) => {
  const { setListRowParams } = useListRowInfStroe.getState();

  const params = {
    no: props.data.rmNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};

// 수정
export const update = (props: any) => {
  const { setListRowParams } = useListRowInfStroe.getState();

  const params = {
    no: props.data.rmNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};

// 상태변경
export const status = (props: any) => {
  const { setListRowParams } = useListRowInfStroe.getState();

  const params = {
    no: props.data.rmNo,
    rgSeq: 1,
    btnNm: "uyn" + "_" + (props.data.uyn === "Y" ? "N" : "Y"),
  };

  setListRowParams(params);
};
